import { TFunction } from "i18next";
import { formartNumberToPercentage } from "@/core/utils";
import type { Insight } from "../types";
import { productTypeNames } from "@/core/utils";
import { useTranslation } from "react-i18next";
import { formatDate, formatMonth } from "@/core/utils";

export function buildInsightMessage(
  insight: Insight,
  t: TFunction<"insights">,
): string {
  const [translate] = useTranslation(["insights"]);
  switch (insight.type) {
    case "identified_growth": {
      const { space_name, growth, previous_month, current_month } =
        insight.data || {};
      return t("report-viewer-insights-list-identified-growth-message", {
        space_name,
        growth: formartNumberToPercentage(Number(growth)),
        previous_month:
          formatMonth(previous_month).m + "/" + formatMonth(previous_month).y,
        current_month:
          formatMonth(current_month).m + "/" + formatMonth(current_month).y,
      });
    }

    case "geographic_expansion": {
      const { city_name, growth, previous_month } = insight.data || {};
      return t("report-viewer-insights-list-geographic-expansion-message", {
        city_name,
        growth: formartNumberToPercentage(Number(growth)),
        previous_month: formatDate(previous_month),
      });
    }

    case "improvement_opportunity": {
      const { checkin_rate } = insight.data || {};
      return t("report-viewer-insights-list-improvement-opportunity-message", {
        checkin_rate: formartNumberToPercentage(Number(checkin_rate)),
      });
    }

    case "type_preference": {
      const { type_name, percentage } = insight.data || {};
      return t("report-viewer-insights-list-type-preference-message", {
        type_name: translate(
          productTypeNames[type_name as keyof typeof productTypeNames],
        ),
        percentage: formartNumberToPercentage(Number(percentage)),
      });
    }

    default: {
      return t("report-viewer-insights-list-default-message");
    }
  }
}
